import offerCard1 from '../../assets/img/offercard1.svg';
import offerCard2 from '../../assets/img/offercard2.svg';
import offerCard3 from '../../assets/img/offercard3.svg';
import offerCard4 from '../../assets/img/offercard4.svg';
import offerCard5 from '../../assets/img/offercard5.svg';
import offerCard6 from '../../assets/img/offercard6.svg';
import offerCard7 from '../../assets/img/offercard7.svg';
import offerCard8 from '../../assets/img/offercard8.svg';


const cardData= (t) => { 
  
  const cardDataData = [
    {
      img:offerCard1,
      description:t( "offer_card_capture1"),
      text:t("offer_card_description1")
    },
    {
      img:offerCard2,
      description:t( "offer_card_capture2"),
      text:t("offer_card_description2")
    },
    {
      img:offerCard3,
      description:t( "offer_card_capture3"),
      text:t("offer_card_description3")
    },
    {
      img:offerCard4,
      description:t( "offer_card_capture4"),
      text:t("offer_card_description4")
    },
    {
      img:offerCard5,
      description:t( "offer_card_capture5"),
      text:t("offer_card_description5")
    },
    {
      img:offerCard6,
      description:t( "offer_card_capture6"),
      text:t("offer_card_description6")
    },
    {
      img:offerCard7,
      description:t( "offer_card_capture7"),
      text:t("offer_card_description7")
    },
    {
      img:offerCard8,
      description:t( "offer_card_capture8"),
      text:t("offer_card_description8")
    }
  ]
return cardDataData}

  export default cardData;